import './plugins/polyfills'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './validation'
import { sync } from 'vuex-router-sync'

import VueAbsolutePath from './plugins/VueAbsolutePath'
import VueAnimateOnIntersection from './plugins/VueAnimateOnIntersection'
import './plugins/Viewports'
import 'normalize.css'
import './plugins/Raven'
import { injectAccessibility } from './plugins/accessibility'

sync(store, router)
Vue.use(VueAbsolutePath, { remote: process.env.VUE_APP_ENDPOINT })
Vue.use(VueAnimateOnIntersection)

Vue.config.productionTip = false

injectAccessibility()
router.afterEach(() => {
  injectAccessibility()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
